import * as _ from 'lodash';
import { RiskFactoryPipe } from '../../../../shared/pipes/RiskFactorPipe';
import AlertLevel from '../../../../shared/alert-level/AlertLevel';
import React from 'react';
import { InfoTooltip } from '../../../../shared/info-tooltip/InfoTooltip';

export const RiskFactorScoreTable = ({
    factorHeaders,
    overallRiskLevel,
    details
}) => {
    const makeTooltipMessage = factor => {
        if (!(details[factor] && details[factor].details)) {
            return null;
        }
        return _.map(
            details[factor].details,
            (key, value) => `${toWord(value)}: ${toWord(key)}\n`
        );
    };

    const toWord = word => _.capitalize(_.startCase(word));

    return (
        <table>
            <thead>
                <tr className={'headers no-text-transform'}>
                    {_.map(factorHeaders, factor => (
                        <td key={factor}>{RiskFactoryPipe(factor)}</td>
                    ))}
                </tr>
            </thead>
            <tbody>
                <tr className={'data'}>
                    {_.map(factorHeaders, header => (
                        <td key={header + '-data'}>
                            <span className={'level-with-tooltip'}>
                                <AlertLevel level={overallRiskLevel[header]} />
                                {makeTooltipMessage(header) && (
                                    <InfoTooltip
                                        message={makeTooltipMessage(header)}
                                    />
                                )}
                            </span>
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    );
};
